// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

export const tailwindAnimateExtend = {
  animationDelay: ({ theme }) => ({
    ...theme("transitionDelay"),
  }),
  animationDuration: ({ theme }) => ({
    0: "0ms",
    ...theme("transitionDuration"),
  }),
  animationTimingFunction: ({ theme }) => ({
    ...theme("transitionTimingFunction"),
  }),
  animationFillMode: {
    none: "none",
    forwards: "forwards",
    backwards: "backwards",
    both: "both",
  },
  animationDirection: {
    normal: "normal",
    reverse: "reverse",
    alternate: "alternate",
    "alternate-reverse": "alternate-reverse",
  },
  animationOpacity: ({ theme }) => ({
    DEFAULT: 0,
    ...theme("opacity"),
  }),
  animationTranslate: ({ theme }) => ({
    DEFAULT: "100%",
    ...theme("translate"),
  }),
  animationScale: ({ theme }) => ({
    DEFAULT: 0,
    ...theme("scale"),
  }),
  animationRotate: ({ theme }) => ({
    DEFAULT: "30deg",
    ...theme("rotate"),
  }),
  animationRepeat: {
    0: "0",
    1: "1",
    infinite: "infinite",
  },
  keyframes: {
    enter: {
      from: {
        opacity: "var(--tw-enter-opacity, 1)",
        transform:
          "translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))",
      },
    },
    exit: {
      to: {
        opacity: "var(--tw-exit-opacity, 1)",
        transform:
          "translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))",
      },
    },
  },
};
